import { render, staticRenderFns } from "./ManualRentChange.vue?vue&type=template&id=270252b7&scoped=true&"
import script from "./ManualRentChange.vue?vue&type=script&lang=js&"
export * from "./ManualRentChange.vue?vue&type=script&lang=js&"
import style0 from "./ManualRentChange.vue?vue&type=style&index=0&id=270252b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270252b7",
  null
  
)

export default component.exports